import { UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE } from '@/common/actions/update';
import { validationSchemaThrottlingSetting } from '../../store';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@apollo/client';
import { Box, Button, Input, TextField, Typography } from '@servicepipe/ui-components';
import React, { useEffect, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

export const RestApiSettingsForm = ({ employee, userId }) => {
  const initialized = useRef(false);

  const [updateEmployee, { loading }] = useMutation(UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE, {
    onCompleted: () => toast.success('Success'),
    onError: (error) => toast.error(error.message),
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchemaThrottlingSetting),
    defaultValues: { restLimit: '', restTtl: '' },
  });

  useEffect(() => {
    if (!employee || initialized.current) {
      return;
    }

    if (employee.restLimit !== undefined && employee.restLimit !== null) {
      setValue('restLimit', employee.restLimit);
    }

    if (employee.restTtl !== undefined && employee.restTtl !== null) {
      setValue('restTtl', employee.restTtl);
    }

    initialized.current = true;
  }, [employee, setValue]);

  const handleUpdateRestApi = (input) => {
    updateEmployee({
      variables: {
        id: userId,
        ...input,
      },
    });
  };

  const handleReset = () => {
    setValue('restLimit', '');
    setValue('restTtl', '');
    handleUpdateRestApi({ restLimit: null, restTtl: null });
  };

  return (
    <form
      onSubmit={handleSubmit((formData) =>
        handleUpdateRestApi({
          restLimit: formData.restLimit ? parseFloat(String(formData.restLimit)) : 0,
          restTtl: formData.restTtl ? parseFloat(String(formData.restTtl)) : 0,
        })
      )}
    >
      <Box direction="column" gap="23px">
        <Box align="center" display="flex" gap="23px">
          <Box minWidth="167px">
            <Controller
              name="restLimit"
              control={control}
              render={({ field: { onChange, value } }) => (
                <TextField
                  id="restLimit"
                  isError={Boolean(errors.restLimit)}
                  helperText={errors?.restLimit?.message || ''}
                >
                  <Input
                    width="100%"
                    type="number"
                    placeholder="60"
                    value={value ?? ''}
                    onChange={onChange}
                  />
                </TextField>
              )}
            />
          </Box>
          <Typography variant="bodySR" color="secondary">
            Limit of requests to the REST API accounted for all users of the client account in total
          </Typography>
        </Box>

        <Box align="center" display="flex" gap="23px">
          <Box minWidth="167px">
            <Controller
              name="restTtl"
              control={control}
              render={({ field: { onChange, value } }) => (
                <TextField
                  id="restTtl"
                  isError={Boolean(errors.restTtl)}
                  helperText={errors?.restTtl?.message || ''}
                >
                  <Input
                    width="100%"
                    type="number"
                    placeholder="30"
                    value={value ?? ''}
                    onChange={onChange}
                  />
                </TextField>
              )}
            />
          </Box>
          <Typography variant="bodySR" color="secondary">
            Time for which the limit of requests to the REST API is taken into account, sec
          </Typography>
        </Box>

        <Box width="100%" justify="right" gap="15px">
          <Button
            variant="outline"
            color="neutral"
            type="button"
            onClick={handleReset}
            isLoading={loading}
          >
            Reset
          </Button>
          <Button type="submit" variant="solid" color="accent" isLoading={loading}>
            Save
          </Button>
        </Box>
      </Box>
    </form>
  );
};
